"use client";

import type { ReactNode } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Footer from "@/app/components/footer";
import Header from "@/app/components/header";

const collageImages = [
  "https://storage.googleapis.com/cuo-website/Comedy+events+in+New+York.jpg",
  ...Array.from({ length: 2 }, (_, i) => `/images/gallery-collage/collage-${i + 2}.png`),
  "https://storage.googleapis.com/cuo-website/Good+comedy+shows+NYC.jpg",
  "https://storage.googleapis.com/cuo-website/Comedy+shows+in+cool+places.jpg",
  "https://storage.googleapis.com/cuo-website/Private+comedy+shows.jpg",
  "/images/gallery-collage/collage-7.png",
  "https://storage.googleapis.com/cuo-website/Marcello+Hernandez+performing.jpg",
];

export default function DashLayout({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Header variant="dark" />
      <Box
        sx={{
          position: "relative",
          flex: 1,
          minHeight: { xs: "min-content", md: "calc(100vh - 120px)" },
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* Collage background grid — dimmed overlay */}
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: -1,
            display: "grid",
            gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(4, 1fr)" },
            gridTemplateRows: { xs: "repeat(4, minmax(72px, 18vh))", md: "repeat(2, 1fr)" },
            minHeight: { xs: "100vh", md: "auto" },
          }}
        >
          {collageImages.map((src, i) => (
            <Box
              key={i}
              sx={{
                backgroundImage: `url('${src}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          ))}
        </Box>
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: -1,
            pointerEvents: "none",
          }}
        />
        <Grid
          container
          direction="column"
          flex={1}
          alignItems="stretch"
          sx={{ position: "relative", zIndex: 0, width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
        >
          {children}
        </Grid>
      </Box>
      <Footer variant="dark" />
    </Box>
  );
}
